import type { AuthClient, AuthStartResult, AuthVerificationResult } from "./auth-client";
import type { AuthAttempt, AuthCallback, AuthReturnTarget } from "./auth-state";

export class AnonymousAuthClient implements AuthClient {
  async start(_returnTo: AuthReturnTarget): Promise<AuthStartResult> {
    return {
      state: "unavailable",
      reason: "Cloud sign-in is not connected in this build. Local Open, Inspect, and Export remain available."
    };
  }

  async verify(_attempt: AuthAttempt, _callback: AuthCallback): Promise<AuthVerificationResult> {
    return { state: "unavailable", reason: "No live identity issuer is configured." };
  }

  async signOut(): Promise<void> {
    return Promise.resolve();
  }
}
